import css from '@styled-system/css';

var sx = function sx(props) {
  return css(props.sx);
};

export default sx;